import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=601358c4&scoped=true"
import script from "./cell.vue?vue&type=script&lang=js"
export * from "./cell.vue?vue&type=script&lang=js"
import style0 from "./cell.vue?vue&type=style&index=0&id=601358c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601358c4",
  null
  
)

export default component.exports